import React, { Component } from 'react'
import Create from '../../../crud/create'
import api from '../../../../api'
import fields from './refund-fields'

class CreateRefund extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      paymentProviders: []
    }
  }

  componentDidMount () {
    api
      .get('admin/payment_providers')
      .then(res => res.json())
      .then(paymentProviders => {
        this.setState({ paymentProviders })
      })
  }

  render () {
    const { order, payment, refunds } = this.props
    const orderPath = `/ecommerce/orders/${order.id}/manage`

    const findPaymentRefundsAmount = payment => {
      const payments = refunds.filter(refund => refund.payment_id === payment.id) || []
      return payments.reduce((accumulatedAmount, payment) => accumulatedAmount + payment.amount, 0)
    }

    const textList = [
      {
        text: 'Payment Value: ',
        value: payment.amount
      },
      {
        text: 'Total Refunded: ',
        value: findPaymentRefundsAmount(payment)
      }
    ]

    return (
      <Create
// @ts-ignore
        title='Create Refund'
        textList={textList}
        fields={fields(this.state.paymentProviders)}
        apiPath='admin/refunds'
        successRedirectPath={orderPath}
        cancelRedirectPath={orderPath}
        onResourceCreated={this.props.onRefundCreated}
        onCancel={this.props.onRefundCanceled}
        resource={{
          payment_id: payment.id,
          amount: payment.amount,
          credit_memo: true
        }}
      />
    )
  }
}

export default CreateRefund
